import Swiper, { Navigation, A11y } from 'swiper';

export default () => {

  const teamSwiperWrapper = document.querySelector(
		'#meet_our_team .meet-our-team-swiper .swiper-wrapper'
	);

  if (teamSwiperWrapper) {
		const teamSwiperAmount = teamSwiperWrapper.dataset.totalTeam;
    // attorney slider
    const teamSwiper = new Swiper('#meet_our_team .meet-our-team-swiper', {
      modules: [Navigation, A11y],
      navigation: {
        nextEl: '#meet_our_team .arrow-next',
        prevEl: '#meet_our_team .arrow-prev',
      },
      loop: true,
      a11y: true,
      keyboardControl: true,
      grabCursor: true,
      breakpoints: {
        320: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 15,
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });

    if( teamSwiperAmount < 5 ) {
      const arrow_prev = document.querySelector('#meet_our_team .arrow-prev');
			const arrow_next = document.querySelector('#meet_our_team .arrow-next');
			arrow_prev.classList.add('d-md-none');
			arrow_next.classList.add('d-md-none');
    }
  }
};
